import React, { useEffect } from 'react';
import Cal, { getCalApi } from '@calcom/embed-react';
import calConfig from '../../config/calConfig';
import { trackCalBookings } from '../../analytics';
import './CalBooking.css';

const CalBooking = () => {
  useEffect(() => {
    (async function () {
      const cal = await getCalApi({ namespace: calConfig.namespace });
      cal('ui', { hideEventTypeDetails: false, layout: 'month_view' });
      trackCalBookings(cal);
    })();
  }, []);

  return (
    <div className="cal-booking-container" id="cal-booking-container">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="cal-booking-wrapper">
              <div className="cal-booking-title">
                <h2>Reserva tu Asesoría Jurídica</h2>
                <p>
                  Selecciona la fecha y hora que mejor se adapte a tu
                  disponibilidad. Una vez confirmada tu cita, serás redirigido
                  automáticamente al portal de pago seguro.
                </p>
              </div>

              <div className="cal-embed-container">
                <Cal
                  namespace={calConfig.namespace}
                  calLink={calConfig.calLink}
                  style={{ width: '100%', height: '600px', overflow: 'scroll' }}
                  config={{ layout: 'month_view' }}
                />
              </div>

              <div className="payment-info">
                <p>
                  <strong>💳 Información de Pago:</strong> Al confirmar tu cita,
                  serás redirigido automáticamente al portal de pago seguro de
                  Flow. El valor de la asesoría es de{' '}
                  <strong>$50.000 CLP</strong>.
                </p>
                <p
                  style={{ fontSize: '14px', color: '#666', marginTop: '15px' }}
                >
                  Una vez completado el pago, tu reserva será confirmada
                  automáticamente y recibirás un correo con todos los detalles
                  de tu cita.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalBooking;
